module.exports = new __parcel__URL__("merged-views-illustration.5d9832fd.png").toString();